
export const retrieveHeader = (name) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', window.location.href)
  xhr.send(null);
  return xhr.getResponseHeader(name);
}
